import Repository from '../../repositories/RepositoryFactory';
const ccmObservationRepository = Repository.get('ccmObservation');

export default {
  namespaced: true,
  state: {
    ccmObservationByPatientId: [],
    ccmObservationByCCMRecordId: [],
    ccmObservation: null,
  },
  mutations: {
    STORE_CCM_OBSERVATION_BY_PATIENT_ID (state, payload) {
      state.ccmObservationByPatientId = payload;
    },
    STORE_CCM_OBSERVATION_BY_CCM_RECORD_ID (state, payload) {
      state.ccmObservationByCCMRecordId = payload;
    },
    STORE_CCM_OBSERVATION (state, payload) {
      state.ccmObservation = payload;
    },
    UPDATE_CCM_OBSERVATION (state, payload) {
      state.ccmObservation = {
        ...state.ccmObservation,
        ...payload,
      };
    },
    UPDATE_CCM_OBSERVATION_IN_RECORD_LIST (state, id, payload) {
      const index = state.ccmObservationByCCMRecordId.findIndex(
        (record) => record.id === id,
      );
      if (index !== -1) {
        state.ccmObservationByCCMRecordId.splice(index, 1, {
          ...state.ccmObservationByCCMRecordId[index],
          ...payload,
        });
      }
    },
    REMOVE_CCM_OBSERVATION (state, id) {
      state.ccmObservationByCCMRecordId = state.ccmObservationByCCMRecordId.filter(record => record.id !== id);
    },
  },
  actions: {
    async getCCMObservationByPatientId ({ commit }, patientId) {
      const response = await ccmObservationRepository.getCCMObservationByPatientId(
        patientId,
      );
      commit('STORE_CCM_OBSERVATION_BY_PATIENT_ID', response.data);
    },

    async getCCMObservationByCCMRecordId ({ commit }, ccmRecordId) {
      const response =
        await ccmObservationRepository.getCCMObservationByCCMRecordId(ccmRecordId);

      var conditions = [];
      if (response.data) {
        response.data.forEach((condition) => {
          if (condition.isPrimary) {
            conditions.unshift(condition);
          } else {
            conditions.push(condition);
          }
        });
      }

      commit('STORE_CCM_OBSERVATION_BY_CCM_RECORD_ID', conditions);
    },

    async getCCMObservation ({ commit }, id) {
      const response = await ccmObservationRepository.getCCMObservation(id);
      commit('STORE_CCM_OBSERVATION', response.data);
    },

    async addCCMObservation ({ commit }, body) {
      return await ccmObservationRepository.addCCMObservation(body);
    },

    async updateCCMObservation ({ commit }, request) {
      commit('UPDATE_CCM_OBSERVATION', request.body);
      commit('UPDATE_CCM_OBSERVATION_IN_RECORD_LIST', request.id, request.body);
      return await ccmObservationRepository.updateCCMObservation(
        request.id,
        request.body,
      );
    },

    async deleteCCMObservation ({ commit }, id) {
      commit('REMOVE_CCM_OBSERVATION', id);
      return await ccmObservationRepository.deleteCCMObservation(id);
    },
  },
};
